import React, { useState } from "react";
import {
    Box, Button, Typography, Grid, Tab, Tabs, Avatar, IconButton,
    Tooltip
} from "@mui/material";
import CustomButton from "components/Button";
import { FaPlus } from "react-icons/fa";
import AddNewSchedule from "./AddNewSchedule";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import ScheduleActivitiesSection from "view/baselineSchedule/ScheduleActivitiesSection";
import { useGetAllImplementationScheduleQuery } from "store/slices/apis/masterScheduleSlice";
import ScheduleWorkflowListSection from "view/baselineSchedule/ScheduleWorkflowListSection";
import { usePermission } from "hooks/usePermission";
import ResourceWiseSection from "./ResourceWiseSection";
import { ACTIVITY_WISE_ACCESS, RESOURCE_WISE_ACCESS } from "helpers/permissionConfig";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";

export default function ViewScheduleData() {
    const [isView, setIsView] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [value, setValue] = useState(0); // 0 = Approved, 1 = In progress
    const [selectedProjectId, setSelectedProjectId] = useState(null);

    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("createdDate");
    const showMspSchedule = true;
    const { hasPermission } = useCheckMenuPermission();


    const getAvatarColor = (title) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = title ? title.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };


    const handleAdd = () => {
        setOpen(!open);
    };

    const handleViewClick = (row) => {
        setIsView((prev) => !prev);
        setViewData(row);
        if (row.id || row.projectId) {
            setSelectedProjectId(row.id || row.masterScheduleId);
        }
    };

    const handleViewClose = () => {
        setIsView(false);
        setViewData(null);
        setSelectedProjectId(null);
    };

    const handleEditSchedule = (row) => {
        setIsEdit((prev) => !prev);
        setSelectedData(row);
    };

    const handleEditClose = () => {
        setIsEdit(false);
        setSelectedData(null);
    };

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
        setPageNumber(1);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
    };

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === "asc";
        setSortOrder(isAsc ? "desc" : "asc");
        setSortBy(property);
    };

    const [open, setOpen] = useState(false);


    // const tabs = ["Activity Wise", "Resource Wise"]; // 🔁 swapped order
    const tabs = [{ label: "Activity Wise", index: 0, permissionKey: [ACTIVITY_WISE_ACCESS] }, { label: "Quantity Wise", index: 1, permissionKey: [RESOURCE_WISE_ACCESS] }]
    return (
        <>
            <Grid container spacing={0}>
                <Grid size={12} sx={{ bgcolor: "#FFFFFF", px: 2, py: 1.75, borderBottom: "1px solid #E2E8F0" }}>
                    <Grid size={12}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: "6px",
                                width: "100%",
                            }}
                        >
                            <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <Typography
                                    sx={{
                                        fontWeight: 650,
                                        fontSize: "20px",
                                        lineHeight: "27px",
                                        color: "#0F172A",
                                        fontFamily: "Outfit, sans-serif",
                                    }}
                                >
                                    View Schedule
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: "12px",
                                        lineHeight: "17px",
                                        color: "#64748B",
                                        fontFamily: "Outfit, sans-serif",
                                    }}
                                >
                                    Review activity progress, quantities, resources, and schedule status in one workspace.
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                <Grid
                    size={12}
                    sx={{ px: 2, pt: 1, backgroundColor: "#FFFFFF", borderBottom: "1px solid #E2E8F0" }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            overflowX: "hidden",
                            whiteSpace: "nowrap",
                            p: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "20px",
                                },
                            }}
                        >
                            {tabs?.filter(item => hasPermission(item?.permissionKey) > 0)?.map((label, index) => (
                                <Tab
                                    key={index}
                                    label={
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                    lineHeight: "100%",
                                                    color:
                                                        value === index ? "#0E73F6" : "#7E7E7E",
                                                    fontFamily: "Outfit, sans-serif",
                                                }}
                                            >
                                                {label?.label}
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{
                                        textTransform: "none",
                                        minWidth: "auto",
                                        minHeight: "38px",
                                        paddingBottom: "10px",
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        borderBottom:
                                            value === index
                                                ? "2px solid #0E73F6"
                                                : "2px solid transparent",
                                    }}
                                />
                            ))}
                        </Tabs>

                    </Box>
                </Grid>

                {/* 🔹 Tab content containers */}

                {/* Tab 0: Approved */}
                {value === 0 && (
                    <Grid size={12} sx={{ p: 2 }}>
                        <ScheduleActivitiesSection showMspSchedule={showMspSchedule} columnFiltering={true} showRemarksColumn={true} />
                    </Grid>
                )}

                {/* Tab 1: In progress (existing table moved here) */}
                {value === 1 && (
                    <Grid size={12} sx={{ p: 2 }}>
                        <ResourceWiseSection />
                    </Grid>
                )}
            </Grid>
        </>
    );
}
